<template>
  <div id="plannerAssignSchool">
    <div class="container" style="margin-top: 10px">
      <div class="row header mb-2">
        <div class="col-lg-4">
          <h3 class="text-left mb-3">
            {{ $route.name }}
          </h3>
        </div>
        <div class="col-lg-8 actionDiv">
          <el-select v-model="ddlSchool" @change="BindSemester()" placeholder="Select School">
            <el-option v-for="item in schoolList" :key="item.PK_SCH_ID" :label="item.SCH_Name" :value="item.PK_SCH_ID"> </el-option>
          </el-select>

          <el-select v-model="ddlSemester" @change="getPlannerAssignedToSchool()" placeholder="Select Academic Year">
            <el-option v-for="item in semesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.PK_Semester_ID"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="plannerSummaryInt.length < 1">
          <strong>No Data Found...</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="plannerSummaryInt.length > 0" class="datatable_group">
          <data-tables :data="plannerSummaryInt">
            <el-table-column
              v-for="plannerSummaryInfo in plannerSummary"
              :prop="plannerSummaryInfo.prop"
              :label="plannerSummaryInfo.label"
              :key="plannerSummaryInfo.prop"
              sortable="custom"
            >
            </el-table-column>

            <el-table-column label="Assign" min-width="100px">
              <template slot-scope="scope">
                <el-button type="primary" @click="getAssignedPlannerDetails(scope.row.CrsID, scope.row.SemID, scope.row.SchID, scope.row.LevelType)">
                  Assign
                </el-button>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
    <b-modal
      id="assignedPlannerModel"
      size="lg"
      title="Assigned Planner"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="assignedPlannerShowModel"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12">
          <el-button type="primary" class="mt-2 mb-2" @click="getPlannerUnAssignToSchoolDetails()"> Assign </el-button>
        </div>
        <div class="col-lg-12">
          <div class="empty-list_image" v-if="plannerAssignedListInt.length < 1">
            <strong>No Data Found...</strong>
            <img src="../assets/notfound.png" />
          </div>
          <div v-if="plannerAssignedListInt.length > 0" class="datatable_group">
            <data-tables :data="plannerAssignedListInt" :action-col="plannerAssignedListDelete">
              <el-table-column
                v-for="plannerAssignedListInfo in plannerAssignedList"
                :prop="plannerAssignedListInfo.prop"
                :label="plannerAssignedListInfo.label"
                :key="plannerAssignedListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="unassignPlannerModel"
      size="lg"
      title="Un-Assign Planner"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="unassignPlannerShowModel"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12">
          <div class="empty-list_image" v-if="plannerUnAssignedListInt.length < 1">
            <strong>No Data Found...</strong>
            <img src="../assets/notfound.png" />
          </div>
          <div v-if="plannerUnAssignedListInt.length > 0" class="datatable_group">
            <div class="col-lg-12">
              <el-button type="primary" class="mt-2 mb-2" @click="SavePlannerDetails()"> Save </el-button>
              <el-select v-model="selectedDomain" @change="BindDomain" placeholder="Select Domain">
                <el-option v-for="item in plannerUnAssignedListDomain" :key="item.index" :label="item" :value="item"> </el-option>
              </el-select>
            </div>
            <div class="col-md-auto">
              <data-tables :data="plannerUnAssignedListIntFiltered" @selection-change="changeSelection">
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column
                  v-for="plannerUnAssignedListInfo in plannerUnAssignedList"
                  :prop="plannerUnAssignedListInfo.prop"
                  :label="plannerUnAssignedListInfo.label"
                  :key="plannerUnAssignedListInfo.prop"
                  sortable="custom"
                >
                </el-table-column>
              </data-tables>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataSource from '../data/datasource'

export default {
  name: 'PlannerAssignSchool',
  data() {
    return {
      multipleSelection: [],
      ddlSchool: '',
      schoolList: [],
      ddlSemester: '',
      semesterList: [],

      currentCrsID: '',
      currentSemID: '',
      currentSchID: '',
      currentLevelType: '',

      selectedDomain: '',
      plannerSummaryInt: [],
      plannerSummary: [
        {
          prop: 'Level',
          label: 'Level',
        },
        {
          prop: 'PlannerAssigned',
          label: 'Planner Assigned',
        },
      ],

      plannerAssignedListInt: [],
      plannerAssignedList: [
        {
          prop: 'PlnMasDomain',
          label: 'Domain',
        },
        {
          prop: 'PlnMasGoalsITL',
          label: 'ITL Goals',
        },
        {
          prop: 'PlnMasGoalsNEL',
          label: 'NEL Goals',
        },
        {
          prop: 'PlnMasIndicator',
          label: 'Indicator',
        },
        {
          prop: 'PlnMasIndicatorType',
          label: 'Indicator Type',
        },
        {
          prop: 'PlnMasLang',
          label: 'Language',
        },
        {
          prop: 'PlnMasCourseType',
          label: 'Course Type',
        },
      ],
      plannerAssignedListDelete: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.deletePlannerAssignedToSchoolDetails(row.PlnScadID)
            },
            label: 'Delete',
          },
        ],
      },
      domainFilters: {},

      plannerUnAssignedListInt: [],
      plannerUnAssignedListDomain: [],
      plannerUnAssignedListIntFiltered: [],
      plannerUnAssignedList: [
        {
          prop: 'PlnMasDomain',
          label: 'Domain',
        },
        {
          prop: 'PlnMasGoalsITL',
          label: 'ITL Goals',
        },
        {
          prop: 'PlnMasGoalsNEL',
          label: 'NEL Goals',
        },
        {
          prop: 'PlnMasIndicator',
          label: 'Indicator',
        },
        {
          prop: 'PlnMasIndicatorType',
          label: 'Indicator Type',
        },
        {
          prop: 'PlnMasLang',
          label: 'Language',
        },
        {
          prop: 'PlnMasCourseType',
          label: 'Course Type',
        },
      ],
    }
  },
  async created() {
    this.BindSchool()
  },
  methods: {
    async BindSchool() {
      try {
        const reGloUniCode = await DataSource.shared.getGlobalUniversityCode()
        if (reGloUniCode) {
          if (reGloUniCode.code === '88') {
            window.location.replace('/')
          } else if (reGloUniCode.code === '99') {
            console.log('getAllActiveSchool Error')
          } else {
            let globalUniversityCode = reGloUniCode.GlobalUniversityCode

            const response = await DataSource.shared.getAllActiveSchool('', '')
            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else {
                this.schoolListResponse = response.Table
                this.schoolListResponse.forEach(m => {
                  if (m.PK_SCH_ID !== 'SCH20120000001') {
                    this.schoolList.push(m)
                  }
                })
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindDomain() {
      try {
        this.plannerUnAssignedListIntFiltered = this.plannerUnAssignedListInt.filter(n => n.PlnMasDomain === this.selectedDomain)
      } catch (e) {
        this.results = e
      }
    },
    async BindSemester() {
      try {
        this.plannerSummaryInt = []
        this.ddlSemester = ''
        this.semesterList = []

        const response = await DataSource.shared.getAcademicYearBySchoolID(this.ddlSchool)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.semesterList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerAssignedToSchool() {
      try {
        this.plannerSummaryInt = []

        const response = await DataSource.shared.getPlannerAssignedToSchool(this.ddlSchool, this.ddlSemester)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Get Planner Assigned To School List: Error',
            })
          } else if (response.code === '2') {
            this.plannerSummaryInt = []
          } else {
            this.plannerSummaryInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerAssignedToSchoolDetails(CrsID, SemID, SchID) {
      try {
        this.plannerAssignedListInt = []

        const response = await DataSource.shared.getPlannerAssignedDetialsToSchool(SchID, SemID, CrsID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Get Assigned Planner List: Error',
            })
          } else if (response.code === '2') {
            this.plannerAssignedListInt = []
            this.$refs.assignedPlannerShowModel.show()
          } else {
            this.plannerAssignedListInt = response.Table
            this.$refs.assignedPlannerShowModel.show()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerUnAssignToSchoolDetails() {
      try {
        this.multipleSelection = []
        this.plannerUnAssignedListInt = []

        const response = await DataSource.shared.getPlannerUnAssignToSchool(this.currentCrsID, this.currentSemID, this.currentSchID, this.currentLevelType)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Get Un-Assign Planner List: Error',
            })
          } else if (response.code === '2') {
            this.plannerUnAssignedListInt = []
            this.$refs.unassignPlannerShowModel.show()
          } else {
            this.plannerUnAssignedListInt = response.Table.filter(m => m.PlnMasType === 'ITL')
            this.plannerUnAssignedListIntFiltered = this.plannerUnAssignedListInt
            this.plannerUnAssignedListInt.forEach(n => {
              //
              const pos = this.plannerUnAssignedListDomain.indexOf(n.PlnMasDomain)
              if (pos === -1) {
                this.plannerUnAssignedListDomain.push(n.PlnMasDomain)
              }
            })
            this.$refs.unassignPlannerShowModel.show()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async SavePlannerDetails() {
      try {
        this.$vs.loading()

        let PlannerMasterIDList = []

        this.multipleSelection.forEach(item => {
          let PlannerMasterIDListTemp = {
            PlannerMasterID: item.PlnMasID,
          }

          PlannerMasterIDList.push(PlannerMasterIDListTemp)
        })

        let newPlannerAssignedToSchoolObjJson = {
          CrsID: this.currentCrsID,
          SemID: this.currentSemID,
          SchID: this.currentSchID,
          PlannerMasterIDList: PlannerMasterIDList,
        }

        const response = await DataSource.shared.savePlannerAssignedToSchool(JSON.stringify(newPlannerAssignedToSchoolObjJson))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Save Planner Details: Error',
            })
          } else {
            this.$refs.unassignPlannerShowModel.hide()
            this.getPlannerAssignedToSchoolDetails(this.currentCrsID, this.currentSemID, this.currentSchID)
            this.getPlannerAssignedToSchool()
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async deletePlannerAssignedToSchoolDetails(plannerSchoolAssginDetailsID) {
      try {
        const response = await DataSource.shared.updatePlannerAssignedDetialsToSchool(plannerSchoolAssginDetailsID, 'Delete')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Delete Assigned Planner List: Error',
            })
          } else {
            this.getPlannerAssignedToSchoolDetails(this.currentCrsID, this.currentSemID, this.currentSchID)
            this.getPlannerAssignedToSchool()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    getAssignedPlannerDetails(CrsID, SemID, SchID, LevelType) {
      this.getPlannerAssignedToSchoolDetails(CrsID, SemID, SchID)
      this.currentCrsID = CrsID
      this.currentSemID = SemID
      this.currentSchID = SchID
      this.currentLevelType = LevelType
    },
    changeSelection(val) {
      this.multipleSelection = val
    },
  },
}
</script>

<style scoped>
.actionDiv {
  text-align: right;
}
.domainSelect,
.inputDomainMin {
  width: 100%;
}
</style>
